import { useTranslation } from "../../../../state/i18n";
import { PillSingleSelect } from "../../../../components/menu/Select";
import { getRoleDescription, getRoleName, removeAccountOwner, type GroupedRoles } from "../../../../utils/roleUtil";
import type { Role } from "../../../../state/role";
import type RoleId from "../../../../state/RoleId";
import type { SelectOption } from "../../../../types/Menu";

type CustomerRoleSelectProps = {
  roles: GroupedRoles;
  value: Role;
  onSelect: (roleId: RoleId) => void;
  disabled?: boolean;
};

export const CustomerRoleSelect = (props: CustomerRoleSelectProps) => {
  const { t } = useTranslation();

  const toOption = (role: Role, group?: string): SelectOption<RoleId> => ({
    variant: "text",
    label: getRoleName(role, t),
    description: getRoleDescription(role, t),
    value: role.id,
    group,
  });

  return (
    <PillSingleSelect
      ariaLabel={getRoleName(props.value, t)}
      value={props.value.id}
      options={[
        ...removeAccountOwner(props.roles.accountSystemRoles).map((role) => toOption(role)),
        ...props.roles.accountCustomRoles.map((role) =>
          toOption(
            role,
            t(($) => $.USER_PAGE_SELECT_ROLE_SUB_TITLE),
          ),
        ),
      ]}
      onSelect={props.onSelect}
      disabled={props.disabled ?? false}
    />
  );
};
